// React
import React from 'react';

// Components
import Wrapper from '../../listing/Wrapper/Wrapper';

// Contexts
import { ListingContext } from '../../../contexts/listing';

// Hooks
import useListing from '../../../hooks/useListing';

// Taxonomies
import { engineCore, engineListing } from '../../../taxonomies/engine';

// This component
export default function Engine() {
  // Taxonomies
  const { endpoint } = engineCore();
  const { initialSort, initialFilters, getColumns, getRows, getFilters } = engineListing();

  // Listing
  const {
    page,
    setPage,
    pageSize,
    setPageSize,
    activeFilters,
    saveActiveFilters,
    sortModel,
    setSortModel,
    resetSortModel,
    refreshDataGrid,
    setRefreshDataGrid
  } = useListing(initialSort, initialFilters, endpoint);

  // JSX
  return (
    <ListingContext.Provider
      value={{
        typeOfData: 'taxonomy',
        // Static
        initialFilters,
        endpoint,
        getColumns,
        getRows,
        getFilters,
        // Dynamic
        page,
        setPage,
        pageSize,
        setPageSize,
        activeFilters,
        saveActiveFilters,
        sortModel,
        setSortModel,
        resetSortModel,
        refreshDataGrid,
        setRefreshDataGrid
      }}>
      <Wrapper
        title="Engines"
        buttonNewLabel="New Engine"
        buttonNewUrl="/engine/new"
        exportAction={false}
      />
    </ListingContext.Provider>
  );
}
